import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { getUnlinkCustomerHostawayUrl } from "./api-url.constants";
import { UnlinkCustomerHostawayError } from "./errors";

export const unlinkCustomerHostaway = async (userId?: string): Promise<void> => {
  const response = await typedFetch(getUnlinkCustomerHostawayUrl(userId), {
    method: API_METHODS.DELETE,
  });

  if (!response.ok) throw new UnlinkCustomerHostawayError();
};
